import { CollectionDataList, CollectionsSjMap } from '../types';

export const collectionsSjMapToList = (collections: CollectionsSjMap): CollectionDataList => {
  return Array.from(collections.entries()).map((item) => ({
    name: item[0],
    items: Array.from(item[1].items.values()).map((dtoItem) => dtoItem.decryptedData),
  }));
};
